import { crudService } from '../_services'

export const tipoAjustePontuacaoAction = {
  getTipoAjustePontuacaoSelect,
  onChangeProps,
  editTipoAjustePontuacoesDetails,
  clear,
  clearAll
}

let filterModel = {
  Page: 0,
  Limit: 10,
  Term: ''
};

function getTipoAjustePontuacaoSelect() {
  return (dispatch) => {
    let apiEndpoint = 'tiposAjustesPontuacoes/select'
    crudService
      .get(apiEndpoint)
      .then((response) => {
        if (response.data) {
          dispatch(changeTipoAjustePontuacoesList(response.data))
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

function onChangeProps(props, event) {
  return (dispatch) => {
    if (event.target.type === 'checkbox') {
      dispatch(handleOnChangeProps(props, event.target.checked))
    } else {
      dispatch(handleOnChangeProps(props, event.target.value))
    }
  }
}

export function addTipoAjustePontuacao(payload) {
  return [{ type: 'ADD_TIPO_AJUSTE_PONTUACAO', tipoAjustePontuacao: payload }, clear()]
}

export function changeTipoAjustePontuacoesList(tipoAjustePontuacao, totalRows) {
  return {
    type: 'FETCHED_ALL_TIPO_AJUSTE_PONTUACAO',
    tipoAjustePontuacao: tipoAjustePontuacao,
    totalRegistros: totalRows
  }
}

export function clear() {
  return {
    type: 'TIPO_AJUSTE_PONTUACAO_CLEAR'
  }
}

export function clearAll() {
  return {
    type: 'TIPO_AJUSTE_PONTUACAO_CLEAR_ALL'
  }
}

export function handleOnChangeProps(props, value) {
  return {
    type: 'TIPO_AJUSTE_PONTUACAO_HANDLE_ON_CHANGE',
    props: props,
    value: value
  }
}

export function editTipoAjustePontuacoesDetails(tipoAjustePontuacao) {
  return [
    { type: 'TIPO_AJUSTE_PONTUACAO_DETAIL', tipoAjustePontuacao },
  ]
}

export function updatedTipoAjustePontuacaoInfo() {
  return {
    type: 'TIPO_AJUSTE_PONTUACAO_UPDATED'
  }
}

export function createTipoAjustePontuacaoInfo() {
  return {
    type: 'TIPO_AJUSTE_PONTUACAO_CREATED_SUCCESSFULLY'
  }
}

export function deleteTipoAjustePontuacoesDetails() {
  return {
    type: 'DELETED_TIPO_AJUSTE_PONTUACAO_DETAILS'
  }
}

export function isLoading() {
  return {
    type: 'TIPO_AJUSTE_PONTUACAO_ISLOADING'
  }
}

export function notIsLoading() {
  return {
    type: 'TIPO_AJUSTE_PONTUACAO_NOTISLOADING'
  }
}
